(function () {
  var stickyBar = document.querySelector('.product-sticky-atc');
  if (!stickyBar) return;

  var mainButton = document.querySelector('.product-form__submit:not(.product-sticky-atc__button)');
  if (!mainButton) return;

  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    },
    { threshold: 0 }
  );

  observer.observe(mainButton);
})();
